import React from "react";
import { Box, Container } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

// ایمپورت استایل‌های سوییپر
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const SliderSct = () => {
  const slides = [
    {
      id: 1,
      image: "/media/sliders/instaBanner.webp",
      path: "https://www.instagram.com/adinzone?igsh=ejBpZTlyYWl3OWpy",
    },
    {
      id: 2,
      image: "/media/sliders/musicBanner.webp",
      path: "https://t.me/adinzone_music",
    },
    {
      id: 3,
      image: "/media/sliders/coachBanner.webp",
      path: "https://adinzone.ir/coaches",
    },
    {
      id: 4,
      image: "/media/sliders/gymBanner.webp",
      path: "https://adinzone.ir/gyms",
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        px: { xs: 2, md: 4 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          borderRadius: { xs: "20px", md: "40px" },
          overflow: "hidden",
          boxShadow: "0px 20px 50px rgba(0, 0, 0, 0.2)",
          position: "relative",
          px: "0 !important",
          aspectRatio: "6/3",

          // ---- شخصی‌سازی دکمه‌های سوییپر برای موبایل و دسکتاپ ----
          "& .swiper-button-next, & .swiper-button-prev": {
            color: "rgba(255, 255, 255, 0.8)", // رنگ فلش‌ها
            "&:hover": {
              color: "white",
            },
            "&::after": {
              // سایز فلش‌ها: در موبایل 18px، در دسکتاپ 35px
              fontSize: { xs: "18px", md: "35px" },
              fontWeight: "bold",
            },
          },
          // استایل نقطه‌های صفحه‌بندی (Pagination)
          "& .swiper-pagination-bullet": {
            width: { xs: "6px", md: "10px" },
            height: { xs: "6px", md: "10px" },
            backgroundColor: "white",
            opacity: 0.5,
          },
          "& .swiper-pagination-bullet-active": {
            opacity: 1,
          },
        }}
      >
        <Swiper
          modules={[Navigation, Pagination, Autoplay, EffectFade]}
          effect="fade"
          spaceBetween={0}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          style={{ width: "100%", height: "100%" }}
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id}>
              <Box
                component={"a"}
                href={slide?.path}
                target="_blank"
                sx={{
                  width: "100%",
                  height: "100%",
                  backgroundImage: `url(${slide.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </Box>
  );
};

export default SliderSct;
